<template>
  <div class="benefits-list">
    <div class="container">
      <ShadowTitle :title="`SPACE EVENT для тех, кто:`"
                   title-shadow="COURSE"
      />
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4">
          <div class="benefit-item">
            <div class="benefit-item_icon">
              <img class="img-fluid" :src="require(`@/assets/benefits/benefit-1.svg`)">
            </div>
            <div class="benefit-item_text">
              верит, что психика <br>и мышление определяют <br>результаты жизнедеятельности
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div class="benefit-item">
            <div class="benefit-item_icon">
              <img class="img-fluid" :src="require(`@/assets/benefits/benefit-2.svg`)">
            </div>
            <div class="benefit-item_text">
              желает сопоставить свои цели <br>с тенденциями развития общества, <br>бизнеса и человека
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div class="benefit-item">
            <div class="benefit-item_icon">
              <img class="img-fluid" :src="require(`@/assets/benefits/benefit-3.svg`)">
            </div>
            <div class="benefit-item_text">
              хочет получить уникальные инструменты накопления, сохранения и приумножения своего социального капитала
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div class="benefit-item">
            <div class="benefit-item_icon">
              <img class="img-fluid" :src="require(`@/assets/benefits/benefit-4.svg`)">
            </div>
            <div class="benefit-item_text">
              ищет возможности <br>и ресурсы для реализации <br>изменений в своей жизни
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div class="benefit-item">
            <div class="benefit-item_icon">
              <img class="img-fluid" :src="require(`@/assets/benefits/benefit-5.svg`)">
            </div>
            <div class="benefit-item_text">
              хочет узнать о возможностях пространства SPACE для увеличения своего дохода <br>и реализации себя, как эксперта
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div class="benefit-item">
            <div class="benefit-item_icon">
              <img class="img-fluid" :src="require(`@/assets/benefits/benefit-6.svg`)">
            </div>
            <div class="benefit-item_text">
              хочет познакомиться с интересными, успешными предпринимателями и людьми в сфере well being
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShadowTitle from "@/components/ShadowTitle";

export default {
  name: "BenefitsList",
  components: {ShadowTitle}
}
</script>

<style lang="scss" scoped>
.benefit-item {
  margin-bottom: 32px;

  .benefit-item_icon {
    margin-bottom: 16px;
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    @include _768 {
      margin-bottom: 36px;
    }
  }

  .benefit-item_text {
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 136%; /* 24.48px */
  }
}
</style>